export default "__VITE_ASSET__DCN9LJQo__"